import { STORAGE_KEY } from '@/services/userbeat/constants';
import { Metric } from '@/services/userbeat/types';

export function updateLocalStorage(metricName: string) {
  const currentValue = readMetrics();

  const filteredValues = currentValue.filter(
    (metric) => metric.metricName !== metricName,
  );
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify([
      ...filteredValues,
      { metricName: metricName, lastSend: new Date().toUTCString() },
    ]),
  );
}

export function readMetrics(): Metric[] {
  const currentValueString = localStorage.getItem(STORAGE_KEY) ?? '[]';
  const currentValue = JSON.parse(currentValueString) as Metric[];

  return currentValue;
}
